var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDonationFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M20.7 13.5a.3.3 0 0 1 .3.3v5.95q0 3-3 3H6q-3 0-3-3V13.8a.3.3 0 0 1 .3-.3zM17.476 5.79c1.582.182 1.817 1.002 2.141 2.13l.003.01 1.054 3.688a.3.3 0 0 1-.288.382H3.614a.3.3 0 0 1-.288-.382L4.38 7.93l.003-.01c.324-1.128.56-1.948 2.14-2.13.323.828.826 1.567 1.399 2.21H7.75a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-.174c.573-.643 1.075-1.382 1.399-2.21"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M10.113 1.5c-1.895.01-2.64 1.766-2.3 3.514C8.05 6.22 8.838 7.21 9.668 7.949h4.667c.83-.74 1.617-1.729 1.853-2.935.341-1.748-.401-3.504-2.302-3.514C12.473 1.493 12 2.906 12 2.906s-.474-1.412-1.886-1.406"
})));
export default SvgDonationFill;